import { createTheme } from "@material-ui/core/styles";
import * as materialColors from "@material-ui/core/colors";

export { muiTheme };

const muiTheme = createTheme({
	typography: {
		fontFamily: "Exo",
		fontSize: 13,
	},
	palette: {
		primary: {
			main: "#5896d2",
			dark: materialColors.blue[800],
			light: materialColors.blue[50],
			contrastText: "#fff",
		},
		secondary: {
			main: materialColors.grey[600],
			dark: materialColors.grey[700],
		},
		error: {
			main: materialColors.red[700],
		},
	},
	overrides: {
		MuiCssBaseline: {
			"@global": {
				body: {
					fontFamily: "Exo",
					color: materialColors.grey[700],
					margin: 0,
					padding: 0,
					overflow: "hidden",
					backgroundColor: "white",
				},
			},
		},
		MuiTypography: {
			h6: { color: "#5896d2" },
			subtitle1: { color: materialColors.grey[700] },
			button: { color: materialColors.grey[700] },
		},
		MuiInput: {
			underline: {
				"&:after": {
					borderBottom: `2px solid #5896d2`,
				},
			},
			input: {
				color: materialColors.grey[700],
				overflow: "hidden",
			},
		},
		MuiFormHelperText: {
			root: { wordBreak: "break-all" },
		},
		MuiCardHeader: {
			root: { padding: "16px 20px 16px 16px !important" },
			subheader: { fontSize: "1rem" },
			title: {
				fontSize: "1.5rem",
				color: "#5896d2",
			},
		},
		MuiTablePagination: {
			root: {
				position: "fixed",
				left: 0,
				background: "#fff",
				bottom: 0,
				right: 0,
				boxShadow: "0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
			},
		},
		MuiListItem: {
			dense: {
				paddingTop: 0,
				paddingBottom: 0,
			},
		},
		MuiListItemIcon: {
			root: {
				minWidth: 35,
			},
		},
		MuiExpansionPanel: {
			root: {
				"&:before": {
					height: "0 !important",
				},
			},
		},
		MuiTooltip: {
			tooltip: {
				maxWidth: 300,
			},
		},
		MuiButton: {
			textSecondary: {
				color: "white",
				"&$disabled": {
					color: "#35689a",
				},
			},
		},
		MuiIconButton: {
			root: {
				padding: "8px",
			},
		},
		MuiAppBar: {
			root: {
				minHeight: 0,
				height: 48,
			},
		},
	},
});
